<template>
  <div>
     <h5>Select Segment</h5>
    <dynamic-rules
      style="max-width: 700px"
      v-if="isDynamic"
      @apply="onApplyDynamicRules"/>
    
   
    <b-form-select
      v-else
      :options="options_with_collection_v2"
      @change="onSegmentChange"
      :value="id"
      
      style="max-width: 400px;"
      size="lg"/>
      

    
    <!-- @change="onSegmentChange" -->
     <!--<div>
      <b-button variant="link" @click="onSegmentChange('')" v-if="isDynamic">
        Filter by Pre-defined Segments
      </b-button>
      <b-button variant="link" @click="onSegmentChange('dynamic')" v-else>
        Use Dynamic Filters
      </b-button>
    </div>-->
  </div>
</template>

<script>
  import DynamicRules from './DynamicRules';

  export default {
    name: 'FilterInput',

    components: {
      DynamicRules
    },

    props: {
      segmentID: String,
      projectID: String,
      meta: String,
      value: Object,
      view: String,
      collection_value: String
    },
  
    created() {
      this.initializeFilter();
    },
    // data(){
    //   return{
    //     selected:''
    //   };
    // },
    watch: {
      segmentID() {
        this.initializeFilter();
      }
    },

    methods: {
      onChange(value) {
        this.$emit('input', value);
      },

      onSegmentChange(newID) {
       
        // var subPath = (this.$route.path.indexOf('file') > -1) ? 'file' : 'database';
        this.$router.push(`/segments/${this.projectID}/${this.meta}/${newID}?view=${this.view}`);
        // this.$router.push(`/dashboard/${subPath}/${newID}?view=${this.view}`);
        console.log(this.projectID, this.meta, newID);
      },

      onApplyDynamicRules(rules) {
        this.onChange({
          method: 'dynamic',
          values: rules
        });
      },

      initializeFilter() {
        const id = this.isDynamic ? this.allActorsSegmentID : this.id;
        this.onChange({
          method: 'segment',
          values: {id}
        });
      }
    },

    computed: {
      isDynamic() {
        return this.segmentID === 'dynamic';
      },

      allActorsSegmentID() {
         const all_id =  this.$store.state.segments.segmentList.filter(y => y.collection === this.collection_value && y.locked==true)[0].id;
        // return this.$store.state.segments.segmentList[0].id;
        console.log(all_id);
        return all_id;
      },

      id() {
        return this.segmentID ? this.segmentID : this.allActorsSegmentID;
      },

      name() {
        if (this.isDynamic) return 'Dynamic';
        const {name} = this.$store.getters.getSegment(this.id);
        return name;
      },

      options() {
        return this.$store.state.segments.segmentList.map(
          ({id, name}) => ({text: name, value: id})
        );


      },
      
      options_with_collection() {
        // let defaults_selection = { value: '' , text: "Select Segment", disabled:true};
        let filter_selection = this.$store.state.segments.segmentList.filter(y => y.collection === this.collection_value ).map(
          ({id, name}) => ({text: name, value: id})
        );
        // console.log(filter_selection);
        // const newArray = [defaults_selection].concat(filter_selection);
        return filter_selection;
        // console.log(filter_selection);
       
      },
      
      options_with_collection_v2() {
        let filter_selection = [];
        this.$store.state.segments.segmentList.forEach(segment => {
          if (segment.collection === this.collection_value) {
            if (!!segment.locked) {
              filter_selection.push({text: "All " + this.meta, value: segment.id});
            } else {
              filter_selection.push({text: segment.name, value: segment.id});
            }
          }
        });
        return filter_selection;
      }
    }
  }

</script>

<style scoped>

</style>
